import React from "react";

/**
 * Last-resort safety net. Catches any React rendering error that escapes
 * (browser-extension or otherwise) and shows a graceful fallback instead of
 * a white screen. Should never trigger from our own code.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.warn("[GovBidIQ ErrorBoundary]", error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="grain min-h-screen flex items-center justify-center">
          <div className="max-w-md mx-auto p-8 border border-rose-500/30 bg-[var(--bg-secondary)]">
            <div className="tick-label text-rose-400 mb-2">/ Recoverable error</div>
            <h1 className="font-display font-black text-xl text-slate-100 mb-3">
              Something glitched.
            </h1>
            <p className="text-sm text-slate-400 mb-5">
              An unexpected error occurred. Reload the page to continue —
              your work is preserved.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 bg-sky-500 hover:bg-sky-400 text-slate-950 font-mono text-[11px] tracking-[0.2em] uppercase font-bold px-4 py-2.5"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
